/* eslint import/prefer-default-export: "off" */
import { Node } from "@tiptap/core";

export const OneLine = Node.create({
  name: "oneLine",
  topNode: true,
  content: "block",
});
